import { z } from 'zod';
import { isoDateSchema, uuidSchema } from './common.js';
/**
 * Catch up the books.
 *
 * One button for a business that arrives with a pile of paper: finish the
 * reading, file what the system is sure of, match the bank, rebuild the open
 * returns, then say month by month how close the books are and exactly what
 * is left. Signing is a separate click by a person, never part of the run.
 */
const minor = z.string().regex(/^-?\d+$/);
export const MONTH_STATES = ['closed', 'ready', 'nearly', 'blocked', 'quiet'];
export const monthStateSchema = z.enum(MONTH_STATES);
export const catchUpReportSchema = z.object({
    from: isoDateSchema,
    through: isoDateSchema,
    reading: z.object({
        toRead: z.number().int(),
        inFlight: z.number().int(),
        parked: z.number().int(),
        retrying: z.number().int(),
        dead: z.number().int(),
        spentMinor: minor,
        ceilingMinor: minor,
        estimateMinor: minor,
        canChangeCeiling: z.boolean(),
    }),
    months: z.array(z.object({
        start: isoDateSchema,
        end: isoDateSchema,
        label: z.string(),
        state: monthStateSchema,
        closed: z.boolean(),
        confirmed: z.number().int(),
        drafts: z.number().int(),
        unexplainedMinor: minor,
        checks: z.array(z.object({
            kind: z.string(),
            severity: z.string(),
            count: z.number().int(),
            headline: z.string(),
        })),
    })),
    review: z.array(z.object({ reason: z.string(), count: z.number().int() })),
    signable: z.object({ count: z.number().int(), grossMinor: minor, itcMinor: minor }),
    missingPaper: z.object({
        count: z.number().int(),
        totalMinor: minor,
        lines: z.array(z.object({
            bankTransactionId: uuidSchema,
            postedOn: isoDateSchema,
            description: z.string(),
            amountMinor: minor,
            asked: z.boolean(),
        })),
    }),
    returns: z.array(z.object({
        periodId: uuidSchema,
        label: z.string(),
        start: isoDateSchema,
        end: isoDateSchema,
        status: z.string(),
        filingDueOn: isoDateSchema.nullable(),
        collectedMinor: minor,
        itcMinor: minor,
        netTaxMinor: minor,
    })),
    generatedAt: z.string(),
});
export const catchUpRunSchema = z.object({
    readingQueued: z.number().int(),
    readingRevived: z.number().int(),
    duplicatesSetAside: z.number().int(),
    filed: z.number().int(),
    filingFailed: z.number().int(),
    /** True when filing stopped for time with more left; running again continues. */
    moreToFile: z.boolean(),
    bankMatched: z.number().int(),
    returnsRebuilt: z.number().int(),
});
export const catchUpSignSchema = z.object({
    signed: z.number().int(),
    skipped: z.number().int(),
});
export const catchUpAskRequestSchema = z.object({
    bankTransactionIds: z.array(uuidSchema).min(1).max(100),
});
export const catchUpAskResultSchema = z.object({
    asked: z.number().int(),
    /** One message listing every question with its link, ready to paste. */
    message: z.string(),
});
//# sourceMappingURL=catch-up.js.map